import { atom } from 'jotai';
import { isSameVideoReference } from '../utils/videoReference';

/* video info and video reference for videos which could be selected for an alignment check */
export const videosRequiringAlignmentCheckAtom = atom([]);
videosRequiringAlignmentCheckAtom.debugLabel =
  'videosRequiringAlignmentCheckAtom';

/* video reference of the video selected for alignment check */
export const videoReferenceSelectedForAlignmentCheckAtom = atom(null);
videoReferenceSelectedForAlignmentCheckAtom.debugLabel =
  'videoReferenceSelectedForAlignmentCheckAtom';

/* focus atom for the object which contains video info and video reference which *is* selected for alignment check */
export const videoSelectedForAlignmentCheckAtom = atom((get) => {
  const videosRequiringAlignmentCheck = get(videosRequiringAlignmentCheckAtom);
  const videoReference = get(videoReferenceSelectedForAlignmentCheckAtom);

  if (!videoReference) return null;

  return (
    videosRequiringAlignmentCheck.find((video) =>
      isSameVideoReference(video.videoReference, videoReference),
    ) || null
  );
});
videoSelectedForAlignmentCheckAtom.debugLabel =
  'videoSelectedForAlignmentCheckAtom';

/* remove a video from the list requiring alignment check */
export const removeVideoFromVideosRequiringAlignmentCheckAtom = atom(
  null,
  (_get, set, videoReference) => {
    if (!videoReference) return;
    set(videosRequiringAlignmentCheckAtom, (videos) =>
      videos.filter(
        (video) => !isSameVideoReference(video.videoReference, videoReference),
      ),
    );
  },
);

/* update the cached video info relating to a video requiring alignment check */
export const updateVideoInfoInVideosRequiringAlignmentCheckAtom = atom(
  null,
  (get, set, videoReference, updatedVideoInfo) => {
    const videosRequiringAlignmentCheck = get(
      videosRequiringAlignmentCheckAtom,
    );
    if (!videoReference || videosRequiringAlignmentCheck.length === 0) return;

    set(videosRequiringAlignmentCheckAtom, (videos) =>
      videos.map((video) =>
        isSameVideoReference(video.videoReference, videoReference)
          ? {
              ...video,
              videoInfo: {
                ...video.videoInfo,
                ...updatedVideoInfo,
              },
            }
          : video,
      ),
    );
  },
);
